var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00079 8.00013V14.0001M8.00079 8.00013L6.33412 9.33346M8.00079 8.00013L9.66745 9.33346M3.35679 6.07812C2.72626 6.23679 2.17537 6.62023 1.80762 7.15642C1.43987 7.69261 1.28058 8.34463 1.35966 8.98998C1.43874 9.63534 1.75076 10.2296 2.2371 10.6611C2.72343 11.0927 3.35061 11.3317 4.00079 11.3335H4.66745",
    stroke: "#4C39A4",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5538 4.75913C10.3259 3.85684 9.76349 3.07496 8.98052 2.57197C8.19755 2.06898 7.25261 1.88252 6.33727 2.0504C5.42192 2.21827 4.60466 2.72792 4.05114 3.47602C3.49762 4.22412 3.24927 5.15471 3.35643 6.07913C3.35643 6.07913 3.45843 6.66713 3.6671 7.00046",
    stroke: "#4C39A4",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3346 11.3337C11.8053 11.3333 12.2706 11.2333 12.6999 11.0402C13.1291 10.8471 13.5126 10.5653 13.8251 10.2133C14.1376 9.86131 14.372 9.44713 14.5129 8.99801C14.6538 8.5489 14.6979 8.07504 14.6425 7.60762C14.587 7.14021 14.4332 6.68984 14.1912 6.28615C13.9491 5.88247 13.6243 5.53462 13.2381 5.26552C12.8519 4.99641 12.4132 4.81214 11.9506 4.72483C11.4881 4.63753 11.0123 4.64917 10.5546 4.75899L9.66797 5.00032",
    stroke: "#4C39A4",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocUploadIcon);
export default __webpack_public_path__ + "static/media/docUploadIcon.97452184.svg";
export { ForwardRef as ReactComponent };